import { Users } from '@/lib/icons'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { FieldBinding } from './NumberField'
import { NumberField } from './NumberField'

export interface BloggerRulesSectionProps {
  minFollowers: FieldBinding
  reapplyAfterDays: FieldBinding
  linkWaitDays: FieldBinding
  disabled: boolean
}

/** "🧑 Blogerlar" bo'limi — ro'yxatdan o'tish va havola kutish qoidalari. */
export function BloggerRulesSection({
  minFollowers,
  reapplyAfterDays,
  linkWaitDays,
  disabled,
}: BloggerRulesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users size={16} aria-hidden="true" /> Blogerlar
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col divide-y divide-app-border">
        <NumberField
          id="settings-min-followers"
          label="Minimal obunachi"
          value={minFollowers.value}
          onChange={minFollowers.onChange}
          error={minFollowers.error}
          disabled={disabled}
          placeholder="Masalan: 1000"
        />
        <NumberField
          id="settings-reapply-after-days"
          label="Rad etilgandan qayta ariza"
          unit="kundan keyin"
          value={reapplyAfterDays.value}
          onChange={reapplyAfterDays.onChange}
          error={reapplyAfterDays.error}
          disabled={disabled}
          placeholder="Masalan: 30"
        />
        <NumberField
          id="settings-link-wait-days"
          label="Havola kutish muddati"
          unit="kun"
          value={linkWaitDays.value}
          onChange={linkWaitDays.onChange}
          error={linkWaitDays.error}
          disabled={disabled}
          placeholder="Masalan: 7"
        />
      </CardContent>
    </Card>
  )
}
